import React from 'react';

export const AdminCompanyEdit = () => {
    return <div>HI</div>
}